import React, { useState, useEffect } from "react";
import {
  Button,
  Icon as IconUI,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Header,
  HeaderContent,
  Label,
  Menu,
  Modal,
  Image,
  Popup,
} from "semantic-ui-react";
import { ConfirmModal } from "../../components/Shared";
import { Icon } from "../../assets";
import { AdminMenu, Logout } from "../../components/Admin/AdminLayout";
import "./AdminLayout.scss";
import { useAuth } from "../../hooks";
import { BasicModal } from "../../components/Shared";
import { UserForm } from "../../components/Admin/Users/UserForm";
import { NotificationSettingsForm } from "../../components/Admin/NotificationSettings";
import { Site, Company, Permission, Notifications } from "../../api";
import { useSite } from "../../contexts/SiteContext";
import { formatDateView } from "../../utils/formatDate";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "moment/locale/es";
import "moment/locale/pt-br";
import { useLanguage } from "../../contexts";
import { useCompany } from "../../contexts/CompanyContext";
import { isMaster, isAdmin, hasPermission } from "../../utils/checkPermission";

const siteController = new Site();
const companyController = new Company();
const permissionController = new Permission();
const notificationsController = new Notifications();

const NOTIFICATIONS_POLL_MS = 60000;

export function AdminLayout(props) {
  const { children } = props;
  const { user } = useAuth();
  const navigate = useNavigate();

  // const { site } = useSite();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [showNotificationSettings, setShowNotificationSettings] = useState(false);

  const [reload, onReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseNotificationSettings = () => setShowNotificationSettings((prevState) => !prevState);

  const { language, translations } = useLanguage(); //deberia mantener el estado del idioma crear otro contexto
  //const [language, setLanguage] = useState("Español");

  moment.locale(language === "pt" ? "pt-br" : language);

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const openUpdateUser = () => {
    setTitleModal(`${t("update")} ${user.email}`);
    onOpenCloseModal();
  };

  useEffect(() => {
    if (reload) {
      window.location.reload();
      onReload(false);
    }
  }, [reload]);

  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem("adminMenuCollapsed");
    return saved === "true";
  });

  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen((prev) => !prev);

  return (
    <div className={`admin-layout ${collapsed ? "collapsed" : ""}`}>
      {menuOpen && (
        <div className="admin-layout__overlay" onClick={() => setMenuOpen(false)} />
      )}
      <div className={`admin-layout__left${menuOpen ? " menu-open" : ""}`}>
        <div style={{ marginTop: "40px" }}></div>
        <AdminMenu collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <div className="admin-layout__right">
        <div className="admin-layout__right-header">
          <div
            className="header-brand"
            onClick={() => navigate("/admin/dashboard")}
            style={{ cursor: "pointer" }}
          >
            <img src={`${process.env.PUBLIC_URL}/favicon.png`} alt="sustemia" className="header-brand__icon" />
            <span className="header-brand__text">sustemia</span>
          </div>
          <div className="header-actions">
            <ZoomControls />
            <LanguageSelector />
            <CompanyLabel />
            <NotificationBell t={t} openSettings={onOpenCloseNotificationSettings} />
            <Profile updateUser={openUpdateUser} t={t} user={user} />
            <button
              className={`hamburger-btn${menuOpen ? " open" : ""}`}
              onClick={toggleMenu}
              aria-label="menu"
            >
              <span className="hamburger-btn__bar" />
              <span className="hamburger-btn__bar" />
              <span className="hamburger-btn__bar" />
            </button>
          </div>
        </div>
        <div className="admin-layout__right-content">{children}</div>
        <footer className="admin-layout__footer">
          <span>© 2026 Sustemia</span>
          <span className="admin-layout__footer-sep">·</span>
          <a href="/privacy" className="admin-layout__footer-link">Política de Privacidad</a>
          <span className="admin-layout__footer-sep">|</span>
          <a href="/terms" className="admin-layout__footer-link">Términos y Condiciones</a>
        </footer>
      </div>
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={titleModal}
        size={"small"}
      >
        <UserForm close={onOpenCloseModal} onReload={onReload} user={user} />
      </BasicModal>
      <BasicModal
        show={showNotificationSettings}
        close={onOpenCloseNotificationSettings}
        size={"tiny"}
        className="notification-settings-modal"
      >
        <NotificationSettingsForm close={onOpenCloseNotificationSettings} />
      </BasicModal>
    </div>
  );
}

const SiteSelector = () => {
  const [listSites, setListSites] = useState([]);
  const { site, changeSite } = useSite();
  const handleChange = (event, data) => {
    changeSite(data.value);
  };
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      const response = await siteController.getSites(accessToken);
      if (response) {
        setListSites(response);
      } else {
        setListSites([]);
      }
    })();
  }, [listSites]);

  return (
    <div
      style={{
        background: "white",
      }}
    >
      <span>
        Sitio{" "}
        <Dropdown
          // placeholder='Selecciona una opción'
          // text='Sitio'
          //button
          //className='icon'
          floating
          labeled
          //icon='world'
          style={{
            background: "transparent",
            boxShadow: "none",
            border: "none",
            color: "black",
          }}
          search
          options={listSites.map((option) => ({
            key: option._id,
            text: option.name,
            value: option._id,
          }))}
          onChange={handleChange}
          value={site}
        />
      </span>
    </div>
  );
};

export default SiteSelector;

function ZoomControls() {
  const [zoom, setZoom] = useState(() => {
    const saved = localStorage.getItem("dashboard_zoom");
    return saved ? Number(saved) : 70;
  });

  const handleZoom = (delta) => {
    const next = Math.min(120, Math.max(40, zoom + delta));
    localStorage.setItem("dashboard_zoom", next);
    setZoom(next);
    window.dispatchEvent(new CustomEvent("dashboard-zoom-change", { detail: next }));
  };

  return (
    <div className="header-zoom-controls">
      <button className="header-zoom-btn" onClick={() => handleZoom(-5)} title="Reducir zoom">−</button>
      <span className="header-zoom-label">{zoom}%</span>
      <button className="header-zoom-btn" onClick={() => handleZoom(5)} title="Aumentar zoom">+</button>
    </div>
  );
}

function LanguageSelector() {
  const { language, changeLanguage } = useLanguage();
  const [langOpen, setLangOpen] = useState(false);

  return (
    <div
      className={`header-lang-selector${langOpen ? " open" : ""}`}
      onMouseEnter={() => setLangOpen(true)}
      onMouseLeave={() => setLangOpen(false)}
    >
      {langOpen
        ? ["es", "en", "pt"].map((lang) => (
            <span
              key={lang}
              className={`header-lang-opt${language === lang ? " active" : ""}`}
              onClick={() => { changeLanguage(lang); setLangOpen(false); }}
            >
              {lang.toUpperCase()}
            </span>
          ))
        : (
            <span className="header-lang-opt active">
              {(language || "es").toUpperCase()}
            </span>
          )
      }
    </div>
  );
}

function CompanyLabel() {
  const { company, changeCompany } = useCompany();
  const { site, changeSite } = useSite();
  const { accessToken, user } = useAuth();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const [companies, setCompanies] = useState([]);
  const [sites, setSites] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [siteName, setSiteName] = useState("");
  const [permissionsActive, setPermissionsActive] = useState([]);

  useEffect(() => {
    (async () => {
      if (!user?.role) { setPermissionsActive([]); return; }
      try {
        const response = await permissionController.getMyPermissions(accessToken, true);
        setPermissionsActive(response || []);
      } catch {
        setPermissionsActive([]);
      }
    })();
  }, [accessToken, user]);

  const canViewTotalGroup =
    isMaster(user?.role) ||
    isAdmin(user?.role) ||
    hasPermission(permissionsActive, user?.role?._id, "dashboard", "view_total_group");

  useEffect(() => {
    (async () => {
      const response = await companyController.getCompanies(accessToken, true);
      if (response) {
        if (!isMaster(user?.role)) {
          setCompanies(response.filter((c) => c._id === user?.company));
        } else {
          setCompanies(response);
        }
      }
    })();
  }, [accessToken, user]);

  useEffect(() => {
    if (!company || company === "" || company === "0") {
      setSites([]);
      setCompanyName("");
      return;
    }
    const found = companies.find((c) => c._id === company);
    setCompanyName(found ? found.name : "");
    (async () => {
      const response = await siteController.getSitesByCompany(accessToken, company, true);
      if (response) {
        if (!isMaster(user?.role) && !isAdmin(user?.role) && user?.sites?.length) {
          const allowedIds = user.sites.map((s) => s._id || s);
          setSites(response.filter((s) => allowedIds.includes(s._id)));
        } else {
          setSites(response);
        }
      }
    })();
  }, [company, companies, user]);

  useEffect(() => {
    if (!site || site === "" || site === "0") { setSiteName(""); return; }
    const found = sites.find((s) => s._id === site);
    setSiteName(found ? found.name : "");
  }, [site, sites]);

  const handleCompanyChange = (e, { value }) => {
    changeCompany(value);
    changeSite("");
  };

  const handleSiteChange = (e, { value }) => {
    changeSite(value);
  };

  const label = siteName
    ? siteName
    : sites.length > 0 && company && canViewTotalGroup
      ? "Total grupo"
      : companyName || t("company");

  return (
    <Popup
      on="click"
      position="bottom right"
      className="company-selector-outer-popup"
      trigger={
        <span className="header-company-label header-company-label--clickable">
          <IconUI name="building outline" className="header-company-label__icon" />
          <span className="header-company-label__text">{label}</span>
        </span>
      }
      content={
        <div className="company-selector-popup">
          <Dropdown
            placeholder={t("company")}
            fluid
            selection
            options={companies.map((c) => ({ key: c._id, text: c.name, value: c._id }))}
            value={company || ""}
            onChange={handleCompanyChange}
          />
          {sites.length > 0 && (
            <Dropdown
              placeholder={t("sites")}
              fluid
              selection
              options={[
                ...(canViewTotalGroup ? [{ key: "all", text: "Total grupo", value: "" }] : []),
                ...sites.map((s) => ({ key: s._id, text: s.name, value: s._id })),
              ]}
              value={site || ""}
              onChange={handleSiteChange}
            />
          )}
        </div>
      }
    />
  );
}


function Profile(props) {
  const { updateUser, t, user } = props;
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  const onOpenCloseConfirm = () => setShowConfirm((prev) => !prev);

  const handleLogout = () => {
    logout();
    navigate("/admin");
  };

  const displayName = user?.username || user?.firstname || user?.email?.split("@")[0] || "";
  const initials = displayName.slice(0, 2).toUpperCase();

  return (
    <>
      <Dropdown
        trigger={
          <span className="profile-avatar">
            {initials}
          </span>
        }
        icon={null}
        pointing="top right"
        className="header-menu-dropdown"
      >
        <DropdownMenu className="profile-dropdown-menu">
          <div className="profile-dropdown-header">
            <span className="profile-avatar profile-avatar--lg">{initials}</span>
            <div className="profile-dropdown-info">
              <span className="profile-dropdown-name">{displayName}</span>
              <span className="profile-dropdown-email">{user?.email}</span>
            </div>
          </div>
          <div className="profile-dropdown-divider" />
          <DropdownItem onClick={updateUser} className="profile-dropdown-item">
            <IconUI name="setting" className="profile-dropdown-item__icon" />
            {t("edit_profile")}
          </DropdownItem>
          <div className="profile-dropdown-divider" />
          <DropdownItem onClick={onOpenCloseConfirm} className="profile-dropdown-item profile-dropdown-item--danger">
            <IconUI name="sign out" className="profile-dropdown-item__icon" />
            {t("logout")}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <ConfirmModal
        open={showConfirm}
        title={t("logout")}
        content={t("are_you_sure_you_want_to_log_out")}
        onConfirm={handleLogout}
        onCancel={onOpenCloseConfirm}
      />
    </>
  );
}

function NotificationBell({ t, openSettings }) {
  const { accessToken } = useAuth();
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const fetchUnreadCount = async () => {
      try {
        const response = await notificationsController.getUnreadCount(accessToken);
        setUnreadCount(response.count || 0);
      } catch {
        // Silencioso: un fallo de polling no debe interrumpir la sesión.
      }
    };

    fetchUnreadCount();
    const id = setInterval(fetchUnreadCount, NOTIFICATIONS_POLL_MS);
    return () => clearInterval(id);
  }, [accessToken]);

  const loadNotifications = async () => {
    try {
      const response = await notificationsController.getMyNotifications(accessToken, 10);
      setNotifications(response.notifications || []);
      setLoaded(true);
    } catch {
      setNotifications([]);
    }
  };

  const handleItemClick = async (notification) => {
    if (!notification.read) {
      try {
        await notificationsController.markRead(accessToken, notification._id);
        setUnreadCount((count) => Math.max(0, count - 1));
        setNotifications((prev) =>
          prev.map((n) => (n._id === notification._id ? { ...n, read: true } : n))
        );
      } catch {
        // no-op
      }
    }
    if (notification.link) navigate(notification.link);
  };

  const handleMarkAllRead = async (event) => {
    event.stopPropagation();
    try {
      await notificationsController.markAllRead(accessToken);
      setUnreadCount(0);
      setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
    } catch {
      // no-op
    }
  };

  const handleOpenSettings = (event) => {
    event.stopPropagation();
    openSettings();
  };

  return (
    <Dropdown
      trigger={
        <span className="header-notification-bell">
          <IconUI name="bell outline" />
          {unreadCount > 0 && (
            <Label circular color="red" size="mini" className="header-notification-bell__badge">
              {unreadCount > 9 ? "9+" : unreadCount}
            </Label>
          )}
        </span>
      }
      icon={null}
      pointing="top right"
      className="header-menu-dropdown"
      onOpen={() => { if (!loaded) loadNotifications(); }}
    >
      <DropdownMenu className="profile-dropdown-menu notification-dropdown-menu">
        <div className="profile-dropdown-header notification-dropdown-header">
          <span className="profile-dropdown-name">{t("notifications")}</span>
          <div className="notification-dropdown-header__actions">
            {unreadCount > 0 && (
              <span className="notification-dropdown-mark-all" onClick={handleMarkAllRead}>
                {t("mark_all_as_read")}
              </span>
            )}
            <span
              className="notification-dropdown-settings-btn"
              onClick={handleOpenSettings}
              title={t("notification_settings")}
            >
              <IconUI name="setting" />
            </span>
          </div>
        </div>
        <div className="profile-dropdown-divider" />
        {notifications.length === 0 ? (
          <div className="notification-dropdown-empty">{t("no_pending_alerts")}</div>
        ) : (
          notifications.map((n) => (
            <DropdownItem
              key={n._id}
              onClick={() => handleItemClick(n)}
              className={`profile-dropdown-item notification-dropdown-item${n.read ? "" : " notification-dropdown-item--unread"}`}
            >
              <span className="notification-dropdown-item__title">{n.title}</span>
              <span className="notification-dropdown-item__time">{moment(n.createdAt).fromNow()}</span>
            </DropdownItem>
          ))
        )}
      </DropdownMenu>
    </Dropdown>
  );
}
